import React from 'react';

import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Container, Grid } from '@material-ui/core';

import DashboardPagination from 'components/common/DashboardPagination';
import Icons from 'consts/icons';
import useStyles from 'consts/styles/DetailsScreen';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Tooltip from '@material-ui/core/Tooltip';
import { formStyles } from 'consts/styles/Form';
import CorridorChart from './manageApprovedAreas/charts/ApprovedAreasChart';

const DashboardApprovedAreasDetails = props => {
  const { approvedAreas, zoom } = props;
  const subtitles = useSelector(state => state.language).zonesDetails;
  const [areaToDisplay, setAreaToDisplay] = React.useState(null);
  const [paginationNumber, setPaginationNumber] = React.useState(1);

  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  React.useEffect(() => {
    if (!approvedAreas.length) return;
    setAreaToDisplay(approvedAreas[0]);
  }, [approvedAreas]);

  React.useEffect(() => {
    if (!areaToDisplay) return;
    setAreaToDisplay(approvedAreas[paginationNumber - 1]);
  }, [paginationNumber]);

  return (
    <Grid
      container
      className={`${formClasses.Form}__overflow-component ${formClasses.Form}--flex ${formClasses.Form}--flex--direction ${formClasses.Form}--flex--flex-end`}
    >
      {areaToDisplay ? (
        <>
          <Container>
            <Grid
              container
              spacing={1}
              className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
            >
              <Grid item xs={12}>
                <CorridorChart
                  foundArea={areaToDisplay}
                  chartCases={false}
                  height="200px"
                  showLegend={false}
                />
              </Grid>
            </Grid>
          </Container>
          <Container>
            <Grid
              container
              spacing={1}
              className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
            >
              <Grid item xs={9}>
                <div className={`${formClasses.Form}__label`}>
                  {`${subtitles.uid_}: `}

                  <span
                    className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
                  >
                    {areaToDisplay.uid}
                  </span>
                </div>
              </Grid>
              <Grid
                item
                xs={3}
                align="right"
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--flex-end`}
              >
                <Tooltip title={subtitles.zoom_} placement="right">
                  <Button
                    type="button"
                    fullWidth
                    onClick={() => zoom(areaToDisplay.geojson)}
                    className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                  >
                    <Icons.Zoom.ZoomInOnMap />
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </Container>
          <Container>
            <Grid
              container
              spacing={1}
              className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
            >
              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.name_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.name || areaToDisplay.othername}
                </span>
              </Grid>
              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.type_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.type}
                </span>
              </Grid>

              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.heightMin_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.agl_min} m
                </span>
              </Grid>
              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.heightMax_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.agl_max} m
                </span>
              </Grid>

              <Grid item xs={12}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.description_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.description || '-'}
                </span>
              </Grid>

              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.visibilityType_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.visibility ? (
                    <>
                      <Icons.Filters.ButtonPrivate /> {subtitles.private_}
                    </>
                  ) : (
                    <>
                      <Icons.Filters.ButtonPublic /> {subtitles.public_}
                    </>
                  )}
                </span>
              </Grid>
              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.activityType_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.active ? (
                    <>
                      <Icons.Filters.ActionSuccess />
                      {subtitles.activeYes_}
                    </>
                  ) : (
                    <>
                      <Icons.Filters.ActionFail />
                      {subtitles.activeNo_}
                    </>
                  )}
                </span>
              </Grid>

              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.contact_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.contact || '-'}
                </span>
              </Grid>
              <Grid item xs={6}>
                <span className={`${formClasses.Form}__label`}>
                  {subtitles.width_}
                </span>
                <br />
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {areaToDisplay.width || '-'}
                </span>
              </Grid>
            </Grid>
          </Container>
        </>
      ) : null}

      {approvedAreas.length > 1 && (
        <DashboardPagination
          paginationNumber={paginationNumber}
          setPaginationNumber={setPaginationNumber}
          paginationCounter={approvedAreas.length}
        />
      )}
    </Grid>
  );
};

DashboardApprovedAreasDetails.propTypes = {
  approvedAreas: PropTypes.array.isRequired,
  zoom: PropTypes.func.isRequired,
};

export default DashboardApprovedAreasDetails;
